import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  TextField,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { createnewPermision } from "../../DAL/create";
import { updatePermision } from "../../DAL/update";
import { useSnackbar } from "notistack";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
};

export default function AddPermission({ open, setOpen, Modeltype, Modeldata }) {
  const { enqueueSnackbar } = useSnackbar();
  const [name, setName] = React.useState(Modeldata?.name || "");
  const [id, setid] = React.useState(Modeldata?.id || "");
  const [selectedName, setSelectedName] = React.useState("");
  const [type, setType] = React.useState(false);

  //all items fields
  const items = React.useMemo(
    () => [
      {
        id: 2,
        name: "Users",
        icon: "tabler:users",
      },
      {
        id: 3,
        name: "Schedule PK",
        route: "/pk",
        icon: "game-icons:battle-gear",
      },
      {
        id: 4,
        name: "Moments",
        icon: "mingcute:moment-fill",
      },
      {
        id: 5,
        name: "Video Moments",
        icon: "mingcute:moment-fill",
      },
      {
        id: 6,
        name: "Families",
        route: "/family-list",
        icon: "vaadin:family",
      },
      {
        id: 7,
        name: "Agencies",
        icon: "line-md:list",
      },
      {
        id: 8,
        name: "Ranking",
        icon: "line-md:list",
      },
      {
        id: 9,
        name: "Send Diamonds",
        route: "/diamond-list",
        icon: "famicons:diamond",
      },
      {
        id: 10,
        name: "Send Rcoins",
        route: "/coins-history",
        icon: "wpf:coins",
      },
      {
        id: 11,
        name: "Profile Tags",
        icon: "streamline:user-protection-2shield-secure-security-profile-person-remix",
      },
      {
        id: 12,
        name: "Livestream Tags",
        icon: "hugeicons:tags",
      },
      {
        id: 13,
        name: "Sending Level",
        icon: "carbon:skill-level",
      },
      {
        id: 14,
        name: "Hosting Level",
        icon: "carbon:skill-level",
      },
      {
        id: 15,
        name: "Images",
        route: "/all-images-list",
        icon: "ion:images",
      },
      {
        id: 16,
        name: "Banners",
        icon: "game-icons:vertical-banner",
      },
      {
        id: 17,
        name: "Gifts",
        icon: "fluent-emoji-high-contrast:wrapped-gift",
      },
      {
        id: 18,
        name: "Text Bubbles",
        route: "/text-bubble-list",
        icon: "ion:chatbubbles-sharp",
      },
      {
        id: 19,
        name: "Product Categories",
        route: "/product-categories",
        icon: "ic:outline-category",
      },
      {
        id: 20,
        name: "Products",
        route: "/products",
        icon: "fluent-mdl2:product-variant",
      },
      {
        id: 21,
        name: "SVIP",
        route: "/sviplist",
        icon: "famicons:diamond",
      },
      {
        id: 22,
        name: "Diamond Packages",
        route: "/diamonds-packages",
        icon: "famicons:diamond",
      },
      {
        id: 23,
        name: "Withdraw Payment Methods",
        route: "/withdraw-list",
        icon: "hugeicons:reverse-withdrawal-01",
      },
      {
        id: 24,
        name: "Withdraw Requests",
        route: "/coming",
        icon: "hugeicons:reverse-withdrawal-01",
      },
      {
        id: 25,
        name: "Reports",
        icon: "mdi:report-finance",
      },
      {
        id: 26,
        name: "Merchants",
        route: "/merchant",
        icon: "mdi:users-group",
      },
      {
        id: 27,
        name: "Permissions",
        route: "/permissions",
        icon: "hugeicons:finger-access",
      },
      {
        id: 28,
        name: "Sub Admins",
        route: "/admins",
        icon: "eos-icons:admin-outlined",
      },
      {
        id: 29,
        name: "Reseller",
        route: "/reseller-list",
        icon: "arcticons:lazada-seller-center",
      },
      {
        id: 30,
        name: "Customer",
        route: "/customer-list",
        icon: "mdi:customer-service",
      },
      {
        id: 31,
        name: "Customer Chat",
        route: "/customer-csr",
        icon: "line-md:chat",
      },
      {
        id: 32,
        name: "Donation Logs",
        route: "/donation-list",
        icon: "streamline-freehand:donation-charity-donate-bag-2",
      },
      {
        id: 33,
        name: "Wallet Transaction",
        route: "/transaction-list",
        icon: "streamline-freehand-color:modern-payment-desktop-transaction",
      },
      {
        id: 34,
        name: "Gift Ranking History",
        route: "/gift-ranking-list",
        icon: "solar:ranking-bold-duotone",
      },
    ],
    []
  );

  const flattenedItems = React.useMemo(() => {
    const result = [];
    items.forEach((item) => {
      result.push({ id: item.id, name: item.name });
      if (item.children) {
        item.children.forEach((child) => {
          result.push({
            id: `${item.id}-${child.child_id}`,
            name: `- ${child.name}`,
          });
        });
      }
    });
    return result;
  }, [items]);

  React.useEffect(() => {
    setName(Modeldata?.name || "");
    setid(Modeldata?.id || "");
  }, [Modeldata]);

  const handleClose = () => {
    setOpen(false);
    setName("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) {
      setType(true);
      return;
    }

    try {
      if (Modeltype === "Add") {
        const payload = {
          name: name,
          resource: selectedName,
        };
        const resp = await createnewPermision(payload);
        if (resp.status === 201) {
          enqueueSnackbar("Permission added successfully.", {
            variant: "success",
          });
          handleClose();
        } else {
          enqueueSnackbar(resp?.message[0]?.constraints, {
            variant: "error",
          });
        }
      } else {
        const payload = {
          name: name,
          resource: selectedName,
        };
        const resp = await updatePermision(id, payload);
        if (resp.status == 200) {
          enqueueSnackbar(
            resp?.data?.message || "Permission Updated successfully",
            { variant: "success" }
          );
          handleClose();
        } else {
          enqueueSnackbar(resp?.data?.message || "Something went wrong", {
            variant: "error",
          });
        }
      }
    } catch (err) {
      enqueueSnackbar("Server error", { variant: "error" });
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      BackdropProps={{
        sx: {
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box sx={style}>
        <Typography variant="h6">{Modeltype} Permission Name</Typography>
        <TextField
          sx={{ mt: 2 }}
          fullWidth
          label="Permission Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <FormHelperText sx={{ color: "red" }}>
          {type && !name && "Permission field is required"}
        </FormHelperText>

        <FormControl fullWidth size="small" sx={{ mt: 2 }}>
          <InputLabel id="page-select-label">Resource</InputLabel>
          <Select
            labelId="page-select-label"
            id="page-select"
            value={selectedName}
            label="Page"
            onChange={(e) => setSelectedName(e.target.value)}
          >
            {flattenedItems.map((item) => (
              <MenuItem key={item.id} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
        >
          <Button onClick={handleClose} sx={{ background: "#B1B1B1" }}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!name.trim()}
            className="gradientButton"
            variant="contained"
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
